import React from "react";
import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changePassOtp } from "../../store/actions";
import { toast } from "react-toastify";

const EmailScreen = ({ state, setState, setFieldTab }) => {
  const dispatch = useDispatch();
  // const [state, setState] = useState();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((pre) => ({ ...pre, [name]: value }));
  };

  const handleSubmit = (e, val) => {
    e.preventDefault();

    const callBack = (res) => {
      if (res.status == 200) {
        setFieldTab(val);
        toast.success("OTP Sent!");
      } else {
        toast.error(res.error);
      }
    };

    dispatch(changePassOtp(state, callBack));
  };
  return (
    <Row>
      <Col lg="12" className="my-2">
        <div className="edit-pass d-flex align-items-center">
          <label className="m-0 form-label2 m-0 me-3">Enter Email</label>
        </div>
        <div className={"icon-with-div pass position-relative"}>
          <Form.Control
            type="email"
            name="email"
            value={state?.email}
            onChange={handleChange}
            placeholder=""
          />
        </div>
      </Col>
      <Col lg="12" className="my-2">
        <div className="pt-4 btn-wrp d-flex algign-items-center">
          <Button
            className="d-flex align-items-center justify-content-center me-2"
            onClick={(e) => handleSubmit(e, "otp")}
            disabled={state.email == "" ? true : false}
          >
            Submit
          </Button>
          <Link
            to="/customers"
            className="d-flex btn-2 border align-items-center justify-content-center me-2"
          >
            <span className="me-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
              >
                <path
                  d="M2.8725 3.75L5.5575 1.0575L4.5 0L0 4.5L4.5 9L5.5575 7.9425L2.8725 5.25H12V3.75H2.8725Z"
                  fill="black"
                />
              </svg>
            </span>
            Back
          </Link>
        </div>
      </Col>
    </Row>
  );
};

export default EmailScreen;
